import axios from "axios";

const ApiClientWithCredentials = axios.create({ withCredentials: true });

export default ApiClientWithCredentials;
